var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _ellipse, _path9, _path10, _path11, _path12, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMove(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 64,
    viewBox: "0 0 51 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.07,
    cx: 25.5002,
    cy: 25.4308,
    r: 25.3,
    fill: "#FFA800"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M50.8002 25.4307C50.8002 39.4035 39.473 50.7307 25.5002 50.7307C11.5274 50.7307 0.200195 39.4035 0.200195 25.4307C0.200195 25.4307 8.26642 29.653 16.3002 28.8807C23.1201 28.2251 27.8002 23.7057 37.5752 23.1307C47.3502 22.5557 50.8002 25.4307 50.8002 25.4307Z",
    fill: "#DE614B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M50.8002 25.4312C50.8002 39.404 39.473 50.7312 25.5002 50.7312C11.5274 50.7312 0.200195 39.404 0.200195 25.4312C0.200195 25.4312 5.37519 21.9812 14.5752 23.1312C21.4752 24.2812 26.0752 27.1562 35.8502 26.5812C45.6252 26.0061 50.8002 25.4312 50.8002 25.4312Z",
    fill: "#FFA800"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0785 34.5132L21.8809 26.4229L26.4116 30.6298L21.3146 37.1021C19.875 38.4107 18.9991 38.4982 17.3503 37.8303L5.7002 33.057C6.08131 32.0557 6.77327 31.8147 8.45092 31.6816C12.6401 31.8311 14.7766 32.3877 18.0785 34.5132Z",
    fill: "#BE1FCC",
    stroke: "#57196D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.05 16.0673C20.3968 14.1854 21.416 13.2917 23.4997 11.8604L24.3896 15.4201L21.0726 16.9573L21.3153 22.5397C20.7499 22.5909 20.3444 22.5397 20.0208 21.8924C19.1273 19.413 18.8974 18.131 19.05 16.0673Z",
    fill: "#FFE0B2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0755 17.5236L31.0237 12.1031L35.1498 16.9573L40.5704 15.4201C40.8892 15.812 40.894 16.391 40.5704 16.7146C38.2102 18.1544 36.9241 18.7362 34.7453 19.0608L32.0755 17.5236Z",
    fill: "#FFE0B2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.05 16.0673C20.3968 14.1854 21.416 13.2917 23.4997 11.8604L24.3896 15.4201L21.0726 16.9573L21.3153 22.5397C20.7499 22.5909 20.3444 22.5397 20.0208 21.8924C19.1273 19.413 18.8974 18.131 19.05 16.0673Z",
    stroke: "#57196D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0755 17.5236L31.0237 12.1031L35.1498 16.9573L40.5704 15.4201C40.8892 15.812 40.894 16.391 40.5704 16.7146C38.2102 18.1544 36.9241 18.7362 34.7453 19.0608L32.0755 17.5236Z",
    stroke: "#57196D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5584 10.4526C28.7453 9.82051 27.901 9.34284 26.9614 8.08388C27.7439 7.60682 27.8761 6.9696 28.0142 5.71513L28.8915 5.3642C29.5495 5.15889 29.8083 4.78167 30.2075 3.9605C30.9025 3.46756 31.3333 3.3509 32.313 3.9605C32.5951 4.11918 31.7867 9.66304 31.6112 10.014C31.4357 10.3649 31.0736 10.5966 30.5584 10.4526Z",
    fill: "#FFE0B2",
    stroke: "#57196D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.8536,
    cy: 3.68455,
    rx: 1.62475,
    ry: 1.91147,
    transform: "rotate(28.3877 25.8536 3.68455)",
    fill: "#A189B5",
    stroke: "#57196D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3835 2.3814C31.1885 2.65759 31.7076 3.13066 32.0504 3.78511C31.298 3.4077 30.8943 3.44155 30.2081 3.96057C29.7711 4.94199 29.2829 5.3206 28.0148 5.7152C27.8792 6.93572 27.7096 7.51981 26.962 8.08394C26.3527 6.88662 26.1724 6.21447 26.2601 5.01335C26.3435 3.87284 27.2252 2.90779 28.0148 2.55687C28.8044 2.20594 29.5061 2.08037 30.3835 2.3814Z",
    fill: "#A189B5",
    stroke: "#57196D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M27.707 10.6473L27.8688 9.51465C28.6714 10.2065 29.1299 10.5701 29.9723 10.8091L29.8105 11.3754C28.8885 11.5223 28.4287 11.3533 27.707 10.6473Z",
    fill: "#FFE0B2",
    stroke: "#57196D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2493 30.0642C22.4519 28.5716 21.5578 27.4753 22.0941 25.0482C22.6905 23.1065 24.3594 23.4301 25.0066 20.5985C25.2126 18.882 24.6021 16.4724 23.5504 11.8609C24.8449 11.1327 25.8966 10.6473 27.6765 10.5664C28.4644 11.381 28.9346 11.6036 29.8609 11.2945L30.9935 12.1036C31.8484 14.2199 31.9929 15.5685 31.9644 17.6859C31.4798 21.1196 30.8361 22.7539 29.6181 25.6145L33.906 28.6889C35.4229 29.8876 36.0276 30.6641 36.2523 32.4104L38.8412 44.8696C38.0337 44.9316 37.5929 44.756 36.8186 44.2224C34.1362 40.1682 33.181 37.7808 32.9352 33.2195L25.2493 30.0642Z",
    fill: "#FF5C00"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6181 25.6145L33.906 28.6889C35.4229 29.8876 36.0276 30.6641 36.2523 32.4104L38.8412 44.8696C38.0337 44.9316 37.5929 44.756 36.8186 44.2224C34.1362 40.1682 33.181 37.7808 32.9352 33.2195L25.2493 30.0642C22.4519 28.5716 21.5578 27.4753 22.0941 25.0482C22.6905 23.1065 24.3594 23.4301 25.0066 20.5985C25.2126 18.882 24.6021 16.4724 23.5504 11.8609C24.8449 11.1327 25.8966 10.6473 27.6765 10.5664C28.4644 11.381 28.9346 11.6036 29.8609 11.2945L30.9935 12.1036C31.8484 14.2199 31.9929 15.5685 31.9644 17.6859C31.4798 21.1196 30.8361 22.7539 29.6181 25.6145ZM29.6181 25.6145C28.4596 24.9921 27.7439 24.771 26.3312 24.6437",
    stroke: "#57196D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter0_f_563_903)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.0504,
    cy: 52.3809,
    rx: 12.65,
    ry: 2.75,
    fill: "#BA7D08"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_563_903",
    x: 5.40039,
    y: 41.6309,
    width: 41.2998,
    height: 21.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur_563_903"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMove);
export default __webpack_public_path__ + "static/media/Move.a276c8fcd9f2e5d17fdd4f1be32f0cdc.svg";
export { ForwardRef as ReactComponent };